import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PayScale } from '../entities/pay-scale';

@Injectable()
export class PayScaleService extends BaseCrudService<PayScale> {

  public uri = '/api/payScale/';

  constructor(injector: Injector) {
    super(injector);
  //  console.log('Instance PayScaleService');
  }

  buildSentence(entity?: PayScale, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.baseAmount ?
          `baseAmount${QueryOperator.Contain}${entity.baseAmount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.capType ?
          `capType${QueryOperator.Contain}${entity.capType}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.familyAmount ?
          `familyAmount${QueryOperator.Contain}${entity.familyAmount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.grade ?
          `grade${QueryOperator.Contain}${entity.grade}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.siafCode ?
          `siafCode${QueryOperator.Contain}${entity.siafCode}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.paymentCategory) {
        query = query.concat(entity.paymentCategory.id ?
          `paymentCategory.id${QueryOperator.Equal}${entity.paymentCategory.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.paymentCategory.name ?
          `paymentCategory.name${QueryOperator.Equal}${entity.paymentCategory.name}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
            `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/pay-scale.service.ts